


















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    name: 'FormColorPicker',
})
export default class FormTopicPicker extends Vue {
    @Prop() private colors;
    @Prop() private preselected;

    private selectedColor: string | null = null;

    private mounted() {
        if (this.preselected !== null) {
            this.selectedColor = this.preselected;
        }
    }

    private selectColor(color) {
        this.selectedColor = color;
        this.$emit('colorSelected', color);
    }
}
